// Browser-safe replacement for the `uniqid` package.
//
// The `uniqid` module reads a MAC address via require('os').networkInterfaces()
// to seed its id. In a webpack build that code path was skipped (it guards on
// __webpack_require__), so uniqid effectively ran in its pid+time mode. Under
// Vite that guard no longer applies and it hits Node's `os`, which does not exist
// in the browser. This shim reproduces uniqid's browser-relevant behavior
// (prefix + time-based hexatridecimal id + optional suffix) without any Node
// built-in dependency. API-compatible with the parts this app uses:
//   uniqid(), uniqid(prefix, suffix), uniqid.process(...), uniqid.time(...)

function now() {
  const time = Date.now()
  const last = now.last || time
  now.last = time > last ? time : last + 1
  return now.last
}

// Small random-ish, monotonic-per-call segment to reduce collision risk without
// the process id that Node would provide.
let counter = Math.floor(Math.random() * 0x7fffffff)
function bump() {
  counter = (counter + 1) >>> 0
  return counter.toString(36)
}

function uniqid(prefix, suffix) {
  return (prefix || '') + bump() + now().toString(36) + (suffix || '')
}

uniqid.process = function (prefix, suffix) {
  return (prefix || '') + bump() + now().toString(36) + (suffix || '')
}

uniqid.time = function (prefix, suffix) {
  return (prefix || '') + now().toString(36) + (suffix || '')
}

export default uniqid
